<script>
	// import mainCss from '$lib/styles/main.css';
	import ProductInfoBlock from '$lib/components/ProductInfoBlock.svelte';
    import MainScreen from '../lib/components/MainScreen.svelte';
    import categories from '$lib/json/categories.json';
	import Link from '$lib/components/Link.svelte';
</script>

<svelte:head>
	<title>PROBAITS — продукты для ловли рыбы</title>
	<meta name="description" property="og:description" content="Большой выбор товаров для рыбалки и туризма в наличии. В одном месте спреи, бойлы, прикормки от PROBAITS" />
    <meta property="og:title" content="PROBAITS — продукты для ловли рыбы">
    <meta property="og:url" content="https://pro-baits.pro/">
</svelte:head>

<MainScreen />
<section>
    {#each categories as {header, text, image, reverse, bg, bgMob, fontColor, link, classList, imageWebp, bgFallback}}
        <ProductInfoBlock 
            header={{
                label: header.label,
                fontSize: header.fontSize
            }}
            text={{
                label: text.label,
                fontSize: text.fontSize
            }}
            {classList}
            {image}
            {reverse}
            {bg}
            {bgMob}
            {fontColor}
            {imageWebp}
            {bgFallback}
        >
        <svelte:fragment slot="afterText">
            {#if link}
                <Link href={link} />
            {/if}
        </svelte:fragment>
        </ProductInfoBlock>
    {/each}
</section>

<style>
    @media (min-width:768px){
        section{
            margin-top: 2.8rem;
        }
    }
</style>